import { CustomMenuItem } from '@app/objects/CustomMenuItem';

const servicesChildren: Array<CustomMenuItem> = [
	{
		path: 'https://www.lapoflove.com/our-services/veterinary-hospice',
		name: 'Veterinary Hospice',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/in-home-euthanasia',
		name: 'In-Home Euthanasia',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/aftercare',
		name: 'Cremation & Aftercare',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/our-services/telehospice',
		name: 'Telehospice',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://info.lapoflove.com/keepsakes',
		name: 'Pet Memorial Keepsakes',
		externalLink: true,
		newTab: true,
	},
];

const communityChildren: Array<CustomMenuItem> = [
	{
		path: 'https://www.lapoflove.com/pet-memorial',
		name: 'Pet Memorials',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/veterinarian-testimonials',
		name: 'Testimonials',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/angel-fund',
		name: 'Angel Fund',
		externalLink: true,
		newTab: true,
	},
];

const aboutUsLeft: Array<CustomMenuItem> = [
	{
		path: 'https://www.lapoflove.com/about-us/who-we-are',
		name: 'Who We Are',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://lapoflovejobs.workable.com',
		name: 'Join Our Team',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/about-us/support-center-team',
		name: 'Support Center Team',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/about-us/student-externship',
		name: 'Student Externship',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/in-the-news/press-clippings',
		name: 'In the News',
		externalLink: true,
		newTab: true,
	},
];

const resources: Array<CustomMenuItem> = [
	{
		path: 'https://www.lapoflove.com/resource-center',
		name: 'Family Resource Center',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/how-will-i-know-it-is-time',
		name: 'How Will I Know It\'s Time?',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://petloss.lapoflove.com/',
		name: 'Pet Loss Resource Center',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/newsletter',
		name: 'Senior Pet Digest',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/blog',
		name: 'Blog',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/videos',
		name: 'Videos',
		externalLink: true,
		newTab: true,
	},
	{
		path: 'https://www.lapoflove.com/faq',
		name: 'FAQ',
		externalLink: true,
		newTab: true,
	},
];

export const menuLoL: Array<CustomMenuItem> = [
	{
		path: '',
		name: 'Services',
		children: [servicesChildren],
	},
	{
		path: '',
		name: 'Resources',
		children: [resources],
	},
	{
		path: '',
		name: 'Community',
		children: [communityChildren],
	},
	{
		path: '',
		name: 'About Us',
		children: [aboutUsLeft],
	},
];
